import { render, staticRenderFns } from "./EntregaProdutosComprasItem.vue?vue&type=template&id=674fe0a0"
import script from "./EntregaProdutosComprasItem.vue?vue&type=script&lang=js"
export * from "./EntregaProdutosComprasItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports